import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

interface DropFlashRevealProps {
  children: ReactNode;
  /** Stagger index for grids. */
  index?: number;
  className?: string;
}

// C3 "slide_drop_flash_Card" from animation.md — cards drop in with a brief cyan
// flash instead of a plain fade. Fires once on scroll into view, reduced-motion
// aware. Drop-in alternative to <Reveal> for grids that want more entrance life.
export function DropFlashReveal({ children, index = 0, className = '' }: DropFlashRevealProps) {
  const reduce = useReducedMotion();
  const flashColors = ['rgba(7,78,220,0.30)', 'rgba(255,140,0,0.30)', 'rgba(74,172,0,0.30)', 'rgba(237,2,22,0.30)'];
  const flash = flashColors[index % flashColors.length];
  if (reduce)
    return (
      <div className={className}>{children}</div>
    );
  return (
    <motion.div
      className={`relative ${className}`}
      initial={{ opacity: 0, y: -28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ type: 'spring', stiffness: 220, damping: 20, delay: index * 0.06 }}
    >
      <motion.span
        className="pointer-events-none absolute inset-0 z-20 rounded-2xl"
        style={{ backgroundColor: flash }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: [0, 0.6, 0] }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.6, delay: index * 0.06 + 0.1 }}
        aria-hidden
      />
      {children}
    </motion.div>
  );
}
